import { render } from "./Biei.vue?vue&type=template&id=085c54b3"
import script from "./Biei.vue?vue&type=script&lang=js"
export * from "./Biei.vue?vue&type=script&lang=js"

import "./Biei.vue?vue&type=style&index=0&id=085c54b3&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__